module.exports = __webpack_public_path__ + "img/banner3.dd1d6b3f.png";